<template>
  <b-field
    class="widget-form-field number-stepper"
    :message="errorMessage"
    v-accessible-error
  >
    <div class="stepper-wrapper">
      <button
        type="button"
        class="stepper-btn"
        :disabled="currentValue <= min"
        @click="decrease"
      >
        −
      </button>

      <b-input
        class="widget-field-input stepper-input"
        type="number"
        :min="min"
        :max="max"
        :value="currentValue"
        :placeholder="placeholder"
        :required="required"
        @input="onInput"
      />

      <button
        type="button"
        class="stepper-btn"
        :disabled="isMaxReached"
        @click="increase"
      >
        +
      </button>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'NumberStepper',
  inheritAttrs: false,

  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    placeholder: String,
    required: {
      type: Boolean,
      default: false,
    },
    errorMessage: String,
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    currentValue() {
      const val = Number(this.value);
      if (isNaN(val)) return this.min;
      return val;
    },
    isMaxReached() {
      return this.max !== null && this.currentValue >= this.max;
    },
  },

  methods: {
    increase() {
      if (this.isMaxReached) return;
      this.$emit('input', this.currentValue + this.step);
    },
    decrease() {
      if (this.currentValue <= this.min) return;
      this.$emit('input', this.currentValue - this.step);
    },
    onInput(val) {
      let number = Number(val);
      if (isNaN(number)) number = this.min;
      if (number < this.min) number = this.min;
      if (this.max !== null && number > this.max) number = this.max;

      this.$emit('input', number);
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/_variables.scss';

.number-stepper {
  .stepper-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .stepper-btn {
    color: var(--theme-accent-color);
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 2.5rem;
    align-self: center;
    font-weight: 200;

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .stepper-input {
    text-align: center;

    input {
      text-align: center;
      border-left: none;
      border-right: none;
      height: 100%;
      padding: 0.6rem;
    }
  }

  @at-root #{$broadway} & {
    border: none;
  }
  @at-root #{$glass} & {
    border: none;

    input {
      background: var(--theme-accent-color);
      border-radius: var(--border-radius);
    }
  }
}
</style>
